import { Component, Input, OnInit, inject } from '@angular/core';
import { WidgetBaseDetailComponent } from '../../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { Dialog } from '../../../../../@core/services/modal/modal.interfaces';
import { BaseDetailComponent } from '../../../../../common/base-detail.component';
import { AddressPostalLink } from '../../../../../generated/generated-types';
import { HotkeysService } from '../../../../hotkeys/services/hotkeys.service';
import { AddressPostalLinkService } from '../../../services/address-postal-link.service';
import { AddressPostalLinkFallbackFields } from './address-postal-link-fallback';

@Component({
  selector: 'app-address-postal-link-edit-widget',
  templateUrl: './address-postal-link-edit-widget.component.html',
  providers: [AddressPostalLinkService, HotkeysService],
  standalone: true,
  imports: [
    WidgetBaseDetailComponent
  ]
})
export class AddressPostalLinkEditWidgetComponent extends BaseDetailComponent<AddressPostalLink> implements OnInit, Dialog<AddressPostalLink> {
  @Input() addressId: string;
  // resolveWith: (result?: any) => void;

  private i18n = inject(I18nService);
  private addressPostalLinkService = inject(AddressPostalLinkService);
  protected override crudService = this.addressPostalLinkService;

  constructor() {
    super();
    this.dataTestId.set('address-postal-link-edit-widget');
  }

  ngOnInit() {
    this.fallbackFields = AddressPostalLinkFallbackFields(this.i18n);
    super.ngOnInit();
  }

  ngOnChanges(c: any): void {
    if (c.addressId && c.addressId.currentValue !== c.addressId.previousValue) {
      this.detailModel.addressId = c.addressId.currentValue;
    }
  }

  async save(detailModel?: Partial<AddressPostalLink>, skipDiffCheck?: boolean): Promise<AddressPostalLink> {
    detailModel = detailModel ?? this.detailModel;
    detailModel.addressId = this.addressId;
    let saved = await super.save(detailModel, skipDiffCheck);
    if (this.resolveWith)
      this.resolveWith(saved);
    return saved;
  }

}
